<template>
  <transition name="fade" @blur.native="$emit('close')">
    <v-bar class="scroll-area select-options dropdown-menu dropmenu-toggle">
      <ul ref="dropdownMenu">
        <li v-for="(option, index) in options" v-if="!excluded.includes(getOptionLabel(option))" v-bind:key="index"
            :class="{ active: isOptionSelected(option) }">
          <a @mousedown.prevent="select(option)">
            <slot name="option" v-bind="(typeof option === 'object')?option:{[label]: option}">
              <span class="option-text option-label" v-text="getOptionLabel(option)"></span>
            </slot>
          </a>
        </li>
        <li v-if="!options.length" class="no-options">
          <slot name="no-options">Sorry, no matching options.</slot>
        </li>
      </ul>
    </v-bar>
  </transition>
  <!--  <transition name="fade">-->
  <!--    <ul ref="dropdownMenu" class="dropdown-menu">-->
  <!--      <li v-for="(option, index) in options" v-bind:key="index"-->
  <!--          :class="{ active: isOptionSelected(option) }">-->
  <!--        <a @mousedown.prevent="select(option)">-->
  <!--          <slot name="option" v-bind="(typeof option === 'object')?option:{[label]: option}">-->
  <!--            <img class="option-img" :src="option.imageUrl" alt="">-->
  <!--            <span class="option-text option-label" v-text="option.label"></span>-->
  <!--            <span class="option-text option-country-code">+{{option.countryCode}}</span>-->
  <!--          </slot>-->
  <!--        </a>-->
  <!--      </li>-->
  <!--      <li v-if="!options.length" class="no-options">-->
  <!--        <slot name="no-options">Sorry, no matching options.</slot>-->
  <!--      </li>-->
  <!--    </ul>-->
  <!--  </transition>-->
</template>

<script>
  export default {
    props: {
      excluded: {
        type: Array,
        default: () => []
      },
      value: {
        default: null
      },
      multiple: {
        type: Boolean,
        default: false
      },
      options: {
        type: Array,
        default() {
          return []
        },
      },
      label: {
        type: String,
        default: 'label'
      },
      getOptionLabel: {
        type: Function,
        default(option) {
          if (typeof option === 'object') {
            if (!option.hasOwnProperty(this.label)) {
              return console.warn(
                `[vue-select warn]: Label key "option.${this.label}" does not` +
                ` exist in options object ${JSON.stringify(option)}.\n` +
                'http://sagalbot.github.io/vue-select/#ex-labels'
              )
            }
            if (this.label && option[this.label]) {
              return option[this.label]
            }
          }
          return option;
        }
      },
    },
    methods: {
      /**
       * Check if the given option is currently selected.
       * @param  {Object|String}  option
       * @return {Boolean}        True when selected | False otherwise
       */
      isOptionSelected(option) {
        return this.getOptionLabel(option) === this.getOptionLabel(this.value)
      },
      /**
       * Select a given option.
       * @param  {Object|String} option
       * @return {void}
       */
      select(option) {
        if (!this.isOptionSelected(option)) {
          this.$emit('input', option)
        }
        this.$emit('close')
      },
      deselect(option) {
        if (this.multiple) {
          let ref = -1
          this.mutableValue.forEach((val) => {
            if (val === option || typeof val === 'object' && val[this.label] === option[this.label]) {
              ref = val
            }
          })
          var index = this.mutableValue.indexOf(ref)
          this.mutableValue.splice(index, 1)
        } else {
          this.mutableValue = null
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  @import "sass/fct/variables";

  .dropdown-menu .active > a {
    color: #333;
    background: rgba(50, 50, 50, .1);

    &:after {
      /*
       * required to override bootstrap 3's
       * .dropdown-menu > li > a:hover {} styles
       */
      content: "✔";
      position: absolute;
      right: 7px;
    }
  }

  .dropdown-menu > .highlight > a {
    /*
     * required to override bootstrap 3's
     * .dropdown-menu > li > a:hover {} styles
     */
    /*background: linear-gradient(to right, #82def5 0%, #5ec3f1 100%);*/
    font-weight: bold;
    color: $active-color;
  }

  .dropdown-menu {
    display: block;
    position: absolute;
    top: 110%;
    left: 0;
    /*right: 5px;*/
    /*width: 250px;*/
    z-index: 1000;
    min-width: 150px;
    padding: 5px 0 0 0;
    margin: 0;
    overflow-y: auto;
    /*border: 1.5px solid rgba(0, 0, 0, 0.118);*/
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, .15);
    // border-top: none;
    border-radius: 10px;
    text-align: left;
    list-style: none;
    background: #fff;
  }

  .no-options {
    text-align: center;
  }

  /* List Items */
  .v-select li {
    line-height: 1.42857143; /* Normalize line height */
    &:not(:last-of-type) {
      /*border-bottom: 1px solid #E2E2E2;*/
      background: linear-gradient(#E2E2E2, #E2E2E2) bottom /* left or right or else */
      no-repeat;
      background-size: 85% 1px;
    }
  }

  li > a {
    text-align: left;
    display: block;
    padding: 10px 20px;
    clear: both;
    color: #414141; /* Overrides most CSS frameworks */
    white-space: nowrap;
  }

  li:hover {
    cursor: pointer;
  }


  .highlight:not(:last-child) {
    margin-bottom: 0; /* Fixes Bulma Margin */
  }

  .scroll-area {
    max-height: 320px;
  }
</style>

<style lang="scss">

  //temp
  .select-options.scroll-area.ps .ps__scrollbar-x-rail {
    display: none !important;
  }
</style>
